module.exports = __webpack_public_path__ + "img/header-engagementRingsHalo@2x.64efba8.jpg";